


























































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import {
  TableColumnItemType,
  OperationItemType,
  OptionItemType
} from '../../types/type'
import { UserModule, CommonModule } from '../../store'
import {
  getAllFatherNodeForIdList,
  findOneForOrginationTree,
  getNameTextInOptions,
  findItemForTree
} from '../../utils/toolsForCommon'
import { encode, decode } from 'js-base64'
@Component({
  name: 'tableModule',
  components: {
    'loading-container': () => import('../../components/loading.vue')
  }
})
export default class tableModule extends Vue {
  @Prop({ default: () => [] }) public tableDataList: any[]
  @Prop({ default: () => [] }) public tableColumnList: TableColumnItemType[]
  @Prop({ default: () => [] }) public columnOperationList: OperationItemType[]
  @Prop({ default: false }) public loading: boolean
  @Prop({ default: 0 }) public nowPage: number
  @Prop({ default: 'the_box_inner_table_header_color_green' })
  public tableHeaderColor: string
  // 获取枚举：
  @Prop({ default: () => [] }) public stuStageOptions: OptionItemType[]
  @Prop({ default: () => [] }) public subsidizeNameOptions: OptionItemType[]
  @Prop({ default: () => [] })
  public negativeListWhetherOptions: OptionItemType[]
  @Prop({ default: () => [] })
  public stuDifficultyStageOptions: OptionItemType[]
  @Prop({ default: () => [] })
  public stuDisabilityStageOptions: OptionItemType[]
  @Prop({ default: () => [] }) public subsidizeTypeOptions: OptionItemType[]
  @Prop({ default: () => [] }) public stuGradeOptions: OptionItemType[]
  @Prop({ default: () => [] }) public studyingWayOptions: OptionItemType[]
  @Prop({ default: () => [] }) public genderOptions: OptionItemType[]
  @Prop({ default: () => [] })
  public fundingApplicationOptions: OptionItemType[]
  @Prop({ default: () => [] }) public typeOfReviewOptions: OptionItemType[]
  @Prop({ default: () => [] })
  public typeOfElectronicSealOptions: OptionItemType[]
  @Prop({ default: () => [] })
  public registeredPermanentResidenceOptions: OptionItemType[]
  @Prop({ default: () => [] }) public whetherOnOptions: OptionItemType[]
  @Prop({ default: () => [] })
  public courseManagementDataStatusOptions: OptionItemType[]

  @Prop({ default: () => [] }) public treeDataForDisposeNameSubject: any[]
  @Prop({ default: () => [] }) public optionsForIncOrExp: OptionItemType[]
  @Prop({ default: () => [] }) public userTypeOptions: OptionItemType[]
  @Prop({ default: () => [] }) public enableOptions: OptionItemType[]
  @Prop({ default: () => [] }) public indexConfigFileTypeOptions: OptionItemType[]
  @Prop({ default: () => [] }) public optionsForMeal: OptionItemType[]

  @Prop({ default: () => false }) public borderForTable: boolean

  @Prop({ default: false }) public columnSelection: boolean

  @Prop({ default: null }) public checkedListForTableColumnList: Array<string>

  public multipleSelection: any[] = []

  // image preview：
  public dialogVisibleForLookImage: boolean = false
  public dialogUrlForLookImage: string = ''

  // 附件预览：
  public dialogVisibleForPreviewFile: boolean = false
  public dialogVisiblePreviewUrl: string = ''
  public dialogVisibleiframeShowFlag: boolean = false

  get treeDataForOrganatizion () {
    return CommonModule.treeDataForOrganatizion
  }

  get userInfoAuthority () {
    return UserModule.userInfo ? UserModule.userInfo.resultAuthorityList : []
  }

  get allRole () {
    let _that: any = this
    return _that.$RoleCode
  }

  created () {
    CommonModule.getTreeDataForOrganization()
  }

  operationForButton (item: OptionItemType, row: any) {
    this.$emit('operationForButton', item, row)
  }

  transformForResult (item: any, scopeRowValue: any) {
    let key = item.key
    let res = ''
    switch (key) {
      case 'organizationId':
        {
          let chooseItemForAllFather = getAllFatherNodeForIdList(
            scopeRowValue,
            this.treeDataForOrganatizion
          )
          let idForTown =
            chooseItemForAllFather[chooseItemForAllFather.length - 3]
          let resForTown = findOneForOrginationTree(this.treeDataForOrganatizion, idForTown)
          res = resForTown.name
        }
        break
      case 'organizationIdForSchool':
      case 'orgId':
        {
          let chooseItemForAllFather = getAllFatherNodeForIdList(
            scopeRowValue,
            this.treeDataForOrganatizion
          )
          let idForSchool =
            chooseItemForAllFather[chooseItemForAllFather.length - 1]
          let resForSchool = findOneForOrginationTree(
            this.treeDataForOrganatizion,
            idForSchool
          )
          res = resForSchool ? resForSchool.name : '- -'
        }
        break
      case 'stuStage':
        res = getNameTextInOptions(this.stuStageOptions, scopeRowValue)
        break
      case 'grantName':
        res = getNameTextInOptions(this.subsidizeTypeOptions, scopeRowValue)
        break
      case 'grade':
      case 'studentGrade':
        res = getNameTextInOptions(this.stuGradeOptions, scopeRowValue)
        break
      case 'gender':
        res = getNameTextInOptions(this.genderOptions, scopeRowValue)
        break
      case 'studyingWay':
        res = getNameTextInOptions(this.studyingWayOptions, scopeRowValue)
        break
      case 'whetherRoom':
      case 'whetherCar':
      case 'whetherBigFarmTools':
      case 'whetherCadresChildren':
      case 'whetherVillageCadresChildren':
      case 'whetherFinancialChildren':
        res = getNameTextInOptions(
          this.negativeListWhetherOptions,
          scopeRowValue
        )
        break
      case 'difficultyType':
        res = getNameTextInOptions(
          this.stuDifficultyStageOptions,
          scopeRowValue
        )
        break
      case 'disabilityType':
        res = getNameTextInOptions(
          this.stuDisabilityStageOptions,
          scopeRowValue
        )
        break
      case 'type':
        res = getNameTextInOptions(this.subsidizeTypeOptions, scopeRowValue)
        break
      case 'fundingApplication':
        res = getNameTextInOptions(
          this.fundingApplicationOptions,
          scopeRowValue
        )
        break
      case 'typeOfRollCallFirstTrial':
        res = getNameTextInOptions(this.typeOfReviewOptions, scopeRowValue)
        break
      case 'genderReview':
        res = getNameTextInOptions(this.genderOptions, scopeRowValue)
        break
      case 'electronicSealType':
        res = getNameTextInOptions(
          this.typeOfElectronicSealOptions,
          scopeRowValue
        )
        break
      case 'registeredPermanentResidence':
        res = getNameTextInOptions(
          this.registeredPermanentResidenceOptions,
          scopeRowValue
        )
        break
      case 'whetherRecord':
      case 'whetherSubsistenceAllowances':
      case 'whetherDifficulty':
      case 'whetherOrphan':
      case 'whetherMartyrChild':
      case 'whetherDisability':
        res = getNameTextInOptions(
          this.whetherOnOptions,
          scopeRowValue == 1 ? 0 : 1
        )
        break
      case 'dataStatus':
        res = getNameTextInOptions(
          this.courseManagementDataStatusOptions,
          scopeRowValue
        )
        break
      case 'subject':
      case 'capitalType':
        const itemRes = findItemForTree(this.treeDataForDisposeNameSubject, 'children', 'code', scopeRowValue)
        if (!Object.keys(itemRes).length) {
          res = '- -'
        } else {
          res = itemRes['name']
        }
        break
      case 'incOrExp':
        res = getNameTextInOptions(this.optionsForIncOrExp, scopeRowValue)
        break
      case 'userType':
        res = getNameTextInOptions(this.userTypeOptions, scopeRowValue)
        break
      case 'enable':
        res = getNameTextInOptions(this.enableOptions, scopeRowValue)
        break
      case 'town':
      case 'school':
        const townRes = findItemForTree(this.treeDataForOrganatizion, 'children', 'id', scopeRowValue)
        if (!Object.keys(townRes).length) {
          res = '- -'
        } else {
          res = townRes['name']
        }
        break
      case 'typeFordisposeInCanteenIndexConfig':
        res = getNameTextInOptions(this.indexConfigFileTypeOptions, scopeRowValue)
        break
      case 'meal':
        res = getNameTextInOptions(this.optionsForMeal, scopeRowValue)
        break
    }
    return res
  }

  operationOfimageLook (url: string) {
    let _that: any = this
    if (!url) return _that.$message.warning('暂无图片')
    this.dialogUrlForLookImage = url
    this.dialogVisibleForLookImage = true
  }

  // 预览：
  previewBtn (v) {
    let _that: any = this
    this.dialogVisibleForPreviewFile = true
    let previewUrl =
      _that.$previewURL +
      '/onlinePreview?url=' +
      encodeURIComponent(encode(v.url))
    this.dialogVisiblePreviewUrl = previewUrl
  }

  // 预览框打开的时候：
  dialogVisibleOpened () {
    let _that: any = this
    _that.dialogVisibleiframeShowFlag = false
    _that.$nextTick(() => {
      let iframeBox = document.querySelector('#iframeBoxOfdialogVisible')
      if ((iframeBox as any).attachEvent) {
        ;(iframeBox as any).attachEvent('onload', function () {
          _that.dialogVisibleiframeShowFlag = true
        })
      } else {
        ;(iframeBox as any).onload = function () {
          _that.dialogVisibleiframeShowFlag = true
        }
      }
      _that.dialogVisibleiframeShowFlag = true
    })
  }

  handleSelectionChange (val: any[]): void {
    this.multipleSelection = val
  }
}
